<template>
  <div :class="classTable">
    <el-table
      :data="items"
      :border="board"
      :fit="fit"
      :stripe="stripe"
      :lazy="lazy"
      ref="table"
      v-loading="loading"
      :height="height"
      v-bind="$attrs"
    >
      <el-table-column
        width="50"
        fixed
        align="center"
        v-if="actions !== undefined"
      >
        <template slot="header" slot-scope="scope">
          <i class="el-icon-setting" :key="scope.$index"></i>
        </template>
        <template slot-scope="scope">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="mdi mdi-menu"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(action, index) in actions"
                :key="index"
                :command="{
                  index: scope.$index,
                  row: scope.row,
                  column: scope.column,
                  command: action.command
                }"
                :icon="action.icon"
                >{{ action.label }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>

      <el-table-column
        v-for="(header, index) in headers"
        :key="index"
        :prop="header.prop"
        :label="header.name"
        :width="header.width"
        :min-width="header.minWidth"
        :sortable="header.sortable"
        :resizable="header.resizable"
        :formatter="
          typeof header.formatter === 'function' ? header.formatter : null
        "
        :fixed="header.fixed"
        :align="header.aling"
      >
        <template
          #default="{ row }"
          v-if="typeof header.formatter !== 'function'"
        >
          <div
            v-if="header.formatter"
            :is="header.formatter"
            :row="row"
            :column="header.prop"
          ></div>
          <template v-else>
            {{ row[header.prop] }}
          </template>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin: 10px">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pagination.currentPage"
        :page-size="pagination.pageSize"
        :layout="pageLayout"
        :total="pagination.total"
        hide-on-single-page
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "RabbeyTable",
  props: {
    height: {
      type: [Number, String],
      required: false
    },
    pageLayout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper",
      required: false
    },
    /**
     * Configuration of the columns of the table.
     *
     * Example: headers = [{label: "Label", prop: "Id", width: 80}]
     */
    headers: {
      type: Array,
      required: true
    },
    /**
     * Configuration of table actions.
     *
     * Example: actions = [{icon: "el-icon-view", label: "View", command: "vuew"}]
     */
    actions: {
      type: Array,
      required: false
    },
    /**
     * Indicates if the table will have borders, by default it is true
     * following the table standard.
     */
    board: {
      type: Boolean,
      default: true
    },
    /**
     * The auto table adjusts the width of the columns.
     */
    fit: {
      type: Boolean,
      default: true
    },
    /**
     * Indicates if the table will have stripes.
     */
    stripe: {
      type: Boolean,
      default: true
    },
    /**
     * Indicates heavy load.
     */
    lazy: {
      type: Boolean,
      default: true
    },
    /**
     * Css classes for the table container.
     */
    classTable: {
      type: Object,
      default() {
        return {
          "table-box": true,
          "card-base": true,
          "card-shadow--medium": true
        };
      }
    },
    /**
     * API url for querying table data.
     */
    indexUrl: {
      type: String,
      required: false
    },
    /**
     * Function to overwrite the query response process
     * to the API.
     */
    callbackIndex: {
      type: Function,
      required: false
    },
    /**
     * Esto sirve para pasar los items sin tener que usar el getData.
     * Esto cubre
     */
    defaultItem: {
      type: Array,
      required: false
    }
  },

  data() {
    return {
      items: [],
      pagination: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      loading: false,
      indexConfig: {}
    };
  },
  methods: {
    /**
     * Reference to the table
     */
    table() {
      return this.$refs.table;
    },
    /**
     * This method listens for the number change event
     * of rows per page in the pager.
     * Throws the get: config event to load
     * the request configuration in getData (), since it is
     * configuration is set in the parent component.
     * Then getData () is executed to update the table data.
     * @param {int} val : number of rows per page
     */
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.emitGetData();
    },
    /**
     * This method listens to the page change event
     * in the pager. Throws the get: config event to load
     * the request configuration in getData (), since it is
     * configuration is set in the parent component.
     * Then getData () is executed to update the table data.
     * @param {int} val : page number
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.emitGetData();
    },
    /**
     * This method listens for the command event in the dropdown
     * from table actions
     * @param {Object} command : object with the data of the row invoked
     */
    handleCommand(command) {
      return this.$emit("push:action", command);
    },
    emitGetData() {
      return this.$emit("get:data");
    },
    /**
     * Method to search the table data
     */
    getData() {
      //console.log("SOLICITUD ENVIEDA");
      // starts the loading effect on the table
      this.loading = true;
      // axios request
      this.$http
        .get(this.indexUrl, this.indexConfig)
        .then((resp) => {
          // if the function to process the response has been indicated
          // we use it, otherwise we assume that the answer is
          // a PageModel on the api side.
          if (this.callbackIndex !== undefined) {
            this.callbackIndex(resp);
          } else {
            this.items = resp.data.Items;
            this.pagination.total = resp.data.ItemCount;
            this.pagination.currentPage = resp.data.CurrentPage;
          }
        })
        .catch((err) => {
          if (
            err.response &&
            ![400, 401, 403, 404].includes(err.response.status)
          ) {
            //Standard error
            this.$alert(err.message, err.name, {
              type: "error"
            });
          }
        })
        .finally(() => {
          // The table loading effect ends.
          this.loading = false;
        });
    }
  }
};
</script>
